import { Expose } from "class-transformer";

export class AIRoleInstruction {
  @Expose()
  id!: string;

  @Expose()
  text!: string;

  @Expose()
  isEnabled!: boolean;

  @Expose()
  roleId!: string;

  @Expose()
  createdAt!: Date;

  @Expose()
  updatedAt!: Date;
}

export class AiRole {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  icon!: string;

  @Expose()
  isActive!: boolean;

  @Expose()
  creatorId!: string;

  @Expose()
  createdAt!: Date;

  @Expose()
  updatedAt!: Date;

  @Expose()
  instructions!: AIRoleInstruction[];

  @Expose()
  isOrgShared?: boolean;
}

export type CreateRoleRequest = Omit<AiRole, "id" | "createdAt" | "updatedAt" | "creatorId">;

export type UpdateRoleRequest = Partial<Omit<AiRole, "id" | "createdAt" | "updatedAt" | "creatorId">>;
